import { render } from "./dictMng.vue?vue&type=template&id=4966131f&scoped=true"
import script from "./dictMng.vue?vue&type=script&lang=js"
export * from "./dictMng.vue?vue&type=script&lang=js"

import "./dictMng.vue?vue&type=style&index=0&id=4966131f&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4966131f"]])

export default __exports__